import { ReactComponent as TrendDown } from "assets/TrendDown.svg";
import { ReactComponent as TrendUp } from "assets/TrendUp.svg";

import { ICardElementWithChildren } from "backend/model/model";
import clsx from "clsx";
import ElementLink from "components/link/ElementLink";
import PeriodChip from "design/components/chips/PeriodChip";
import React from "react";
import { makeThemedStyles } from "../../qpr-base/viewcomponents/utils";
import SubElementContents from "./SubElementContents";

interface UpdateProps {
  value: string;
  id?: string;
  name?: string;
}
interface Props {
  isDisabled: boolean;
  elementIndex: number;
  element: ICardElementWithChildren;
  handleFieldElement: (val: UpdateProps) => any;
}
const useStyles = makeThemedStyles("", (theme) => ({
  tableContainer: {
    width: "100%",
    marginBottom: "5px",
  },
  tableHeader: {
    height: "2.4em",
    width: "100%",
    background: "rgb(245, 245, 245)",
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
    color: "rgba(76, 81, 87, 1)",
    fontFamily: "Dubai",
    padding: "1.02em 1.6em 0.8em 1.6em",
    fontWeight: 500,
    fontSize: "1.6em",
    lineHeight: "1.428em",
  },
  borderTop: {
    borderTop: "1px solid rgba(224, 224, 224, 1)",
  },
  elementLink: {
    marginTop: "-10px",
  },
  typeandperiod: {
    margin: "-11px 5px 0 -16px",
  },
  trendUp: {
    color: "rgba(39, 182, 177,.7)",
    marginRight: "6px",
    width: "20px",
    height: "20px",
  },
  trendDown: {
    color: "rgba(189, 41, 44,.8)",
    marginRight: "6px",
    width: "20px",
    height: "20px",
  },
  headerContent: {
    display: "flex",
    marginTop: "-9px",
  },
}));

const SubElementHeader = (props: Props) => {
  const classes = useStyles();
  const { element, isDisabled, elementIndex, handleFieldElement } = props;

  const getTrendIcon = (trend: string) => {
    if (trend === "1")
      return (
        <div className={classes.trendUp}>
          <TrendUp />
        </div>
      );
    if (trend === "-1")
      return (
        <div className={classes.trendDown}>
          <TrendDown />
        </div>
      );
    return null;
  };

  return (
    <div className={classes.tableContainer}>
      <div
        className={clsx(classes.tableHeader, elementIndex && classes.borderTop)}
      >
        <div className={classes.headerContent}>
          <div className={classes.typeandperiod}>
            <PeriodChip
              title={element.typename}
              period={element.periodname || ""}
            />
          </div>
          {getTrendIcon(element.trend || "")}
          {element.name}
          {element.typename === "KPI" || element.typename === "Initiative" ? (
            <div className={classes.elementLink}>
              <ElementLink item={element} />
            </div>
          ) : null}
        </div>
      </div>
      <SubElementContents
        isDisabled={isDisabled}
        handleField={handleFieldElement}
        element={element}
      />
    </div>
  );
};
export default SubElementHeader;
